module.exports = __webpack_public_path__ + "static/media/foodleh.bca86764.png";